import { createSlice } from '@reduxjs/toolkit';
import { fetchProfileEmploymentStatus } from '../thunks/fetch-profile-employment-status-thunk';

const initialState = {
    profileEmploymentStatus: false,
    status: 'idle',
    error: null
};

export const profileEmploymentStatusSlice = createSlice({
    name: 'profileEmploymentStatusSlice',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchProfileEmploymentStatus.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProfileEmploymentStatus.fulfilled, (state, action) => {
                state.status = 'succeeded'
                state.profileEmploymentStatus = action.payload;
            })
            .addCase(fetchProfileEmploymentStatus.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

export const selectProfileEmploymentStatus = (state) => state.profileEmploymentStatusSlice.profileEmploymentStatus;